<template>
<transition name="modal">
    <div v-if="show" ref="modalContainer" :class="modalClasses">
        <div :class="['modal show modal-scroll ']" :style="styleObject" tabindex="-1" role="dialog" @click.self="closeBackdrop" ref="modal">
            <div :class="'modal-dialog ' + modalSizeClasses" role="document">
                <div class="modal-content">
                    <slot></slot>
                </div>
            </div>
        </div>

        <div v-if="includeBackdrop" class="modal-backdrop show" :style="'z-index:' + backdropZIndex + '!important;'"></div>
    </div>
</transition>
</template>

<script>
export default {
    props: {
        "modalClasses": {
            default: ""
        },
		"isXL": {
            default: false
        },
        "isLarge": {
            default: false
        },
        "isSmall": {
            default: false
        },
        "show": {
            default: false
        },

        "includeBackdrop": {
            default: true
        },
        "locked": {
            default:false
        },

		"backdropZIndex": {
			default: 1040
		},

		"modalZIndex": {
			default: null
		},
    },
    data() {

		var obj = {
			display: 'block'
		};

		if(this.modalZIndex){
			obj["z-index"] = this.modalZIndex
		}

        return {
            styleObject: obj,
			isSubModal: false,
        }
    },
    methods: {
        close() {
            this.$emit("close");
        },
        closeBackdrop() {
            if(this.locked){
                return;
            }
            this.close();
        }
    },
    computed: {
        modalSizeClasses() {
            if (this.isLarge) {
                return " modal-lg";
            }
            if (this.isSmall) {
                return " modal-sm";
            }
			if (this.isXL){
				return " modal-xl";
			}

            return "";
        },
    },
    watch:{
        show(value){
            if(value){
				
                var temp = this;
                this.$nextTick(function(){
                    document.body.appendChild(temp.$refs["modalContainer"]);
                })
				var openModals = document.querySelectorAll(".modal");
				if(openModals.length>0){
					this.isSubModal = true;
					return;
				}
                document.body.classList.add("modal-open");
            }else{
				var openModals = document.querySelectorAll(".modal");
				if(!this.isSubModal||openModals.length==1){
					document.body.classList.remove("modal-open");
				}
			}
        },

    },

    mounted() {},
	beforeDestroy(){
		if(this.show){
			document.body.classList.remove("modal-open");
		}
	},
	updated(){
		if(this.show){
			document.body.classList.add("modal-open");
		}
	},
    destroyed() {
        this.$el.remove();
    }
}
</script>

<style lang="less" scoped>
.modal-scroll {
    overflow-y: auto;
    .modal-content {
        overflow: visible;
    }
}

/* Transitions */
.modal-enter-active,
.modal-leave-active {
    transition: opacity .2s linear;
}

.modal-enter-active .modal-backdrop {
    transition: opacity .1s linear;
}

.modal-leave-active .modal-backdrop {
    transition: opacity .1s linear;
    transition-delay: .1s;
}

.modal-enter-active .modal {

    transition: opacity .1s linear;
    transition-delay: .1s;
}

.modal-leave-active .modal {

    transition: opacity .1s linear;
}

.modal-enter .modal,
.modal-leave-to .modal,
.modal-leave-active .modal,
.modal-enter .modal-backdrop,
.modal-leave-to .modal-backdrop,
.modal-leave-active .modal-backdrop {
    opacity: 0
}

.modal-enter .modal-dialog,
.modal-leave-to .modal-dialog,
.modal-leave-active .modal-dialog {
    //transform: translate(0, -5%);
}
</style>
